// src/api/fetchInterceptor.js
import axios from "axios";
import { AUTH_TOKEN_KEY } from "../constants"; // Usa la clave centralizada

const API_URL = process.env.REACT_APP_API_URL;

const service = axios.create({
  baseURL: API_URL,
  timeout: 60000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN_KEY);

    if (jwtToken) {
      config.headers.Authorization = `Bearer ${jwtToken}`; // ✅ Header estándar
    }

    return config;
  },
  (error) => Promise.reject(error) // ✅ No olvidar el return
);

// Interceptor de respuesta para manejar tokens expirados
service.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      console.warn("🔒 Token expirado. Intentando renovar...");
      
      try {
        // Intentar renovar el token usando el refresh token
        const refreshToken = localStorage.getItem('refreshToken');
        if (refreshToken) {
          const response = await axios.post(`${API_URL}/auth/refresh-tokens`, {
            refreshToken: refreshToken
          });
          
          const { access, refresh } = response.data;
          localStorage.setItem(AUTH_TOKEN_KEY, access.token);
          localStorage.setItem('refreshToken', refresh.token);
          
          // Reintentar la petición original con el nuevo token
          originalRequest.headers.Authorization = `Bearer ${access.token}`;
          return service(originalRequest);
        }
      } catch (refreshError) {
        console.error("❌ Error renovando token:", refreshError);
      }
      
      // Si no se puede renovar, cerrar sesión
      console.warn("🔒 No se pudo renovar el token. Cerrando sesión...");
      localStorage.removeItem(AUTH_TOKEN_KEY);
      localStorage.removeItem('refreshToken');
      localStorage.removeItem("userId");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default service;